export default [
    {
        path: '/shipment-type/list',
        name: 'shipment_type_list',
        component: () => import('@src/shipment-type/shipment-type-list.vue'),
        props(route) {
            return { ...route.params };
        },
        meta: {
            title: 'Versandarten',
            role: 'ROLE_LIST_SHIPMENT_TYPE',
        },
    },
    {
        path: '/shipment-type/:id?',
        name: 'shipment_type_detail',
        component: () => import('@src/shipment-type/shipment-type.vue'),
        props(route) {
            return { id: route.params.id ? route.params.id : null };
        },
        meta: {
            title: 'Versandartdetails',
            role: 'ROLE_EDIT_SHIPMENT_TYPE',
        },
    },
];
